import { Shield, ArrowRight, FileText, Lock } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import PublicShell from '@/components/layouts/PublicShell';

const DatenschutzPage = () => {
  return (
    <PublicShell>
      {/* Hero Section - Exact Height */}
      <div className="relative" style={{height: '70vh'}}>
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{backgroundImage: 'url(/images/sv-skyline-evening.jpg)'}}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/75 via-slate-800/60 to-transparent"></div>
        
        <div className="relative z-10 h-full flex items-center px-16">
          <div className="max-w-3xl">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-light text-white mb-8 leading-tight font-serif">
              Datenschutzerklärung
            </h1>
            
            <p className="text-xl md:text-2xl text-slate-200 leading-relaxed mb-10 max-w-3xl">
              Transparenz und Schutz Ihrer persönlichen Daten
            </p>
            
            <div className="text-lg text-slate-300">
              Stand: 14.03.2022
            </div>
          </div>
        </div>
      </div>

      {/* Green Section - Introduction */}
      <div className="bg-primary-800">
        <div className="grid grid-cols-1 lg:grid-cols-5">
          {/* Left Side - Text (3 columns) */}
          <div className="lg:col-span-3 p-12 lg:p-20 flex items-center">
            <div className="max-w-2xl">
              <div className="w-16 h-16 mb-8">
                <Shield className="w-16 h-16 text-white" />
        </div>

              <h2 className="text-4xl md:text-5xl font-light text-white mb-8 leading-tight">
                Schutz Ihrer <em className="italic">persönlichen Daten</em>
          </h2>
          
              <p className="text-xl text-primary-100 leading-relaxed mb-6">
                Wir freuen uns über Ihr Interesse an Sky View Asset Management. Der Schutz Ihrer persönlichen Daten hat für uns höchste Priorität.
              </p>
              
              <p className="text-lg text-primary-100 leading-relaxed">
                Die Nutzung unserer Website ist grundsätzlich ohne Angabe personenbezogener Daten möglich. Wenn Sie jedoch bestimmte Services über unsere Website in Anspruch nehmen möchten, kann die Verarbeitung solcher Daten erforderlich werden.
              </p>
            </div>
          </div>

          {/* Right Side - Image (2 columns) */}
          <div className="lg:col-span-2 relative min-h-96">
            <div 
              className="absolute inset-0 bg-cover bg-center"
              style={{backgroundImage: 'url(/images/sv-skyline-financial.jpg)'}}
            ></div>
          </div>
        </div>
            </div>
            
      {/* Three White Cards Section - Basic Info */}
      <div className="relative -mt-16 z-20">
        <div className="max-w-[1720px] mx-auto px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24">
          {/* Single Large White Box */}
          <div className="bg-white rounded-none shadow-[0_8px_40px_rgba(16,24,40,0.08)] w-full mb-12">
            <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-gray-200">
              {/* Card 1 - DSGVO Konformität */}
              <div className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 py-12 text-left">
                <h3 className="text-xl font-bold text-slate-800 mb-6 leading-tight">DSGVO-Konformität</h3>
                <p className="text-[16px] text-slate-600 leading-relaxed">
                  Die Verarbeitung personenbezogener Daten (z. B. Name, Adresse, E-Mail oder Telefonnummer) erfolgt stets im Einklang mit der Datenschutz-Grundverordnung (DSGVO) sowie den nationalen Datenschutzbestimmungen. Mit dieser Datenschutzerklärung informieren wir Sie über Art, Umfang und Zweck der Datenerhebung und -verarbeitung.
                </p>
              </div>

              {/* Card 2 - Technische Sicherheit */}
              <div className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 py-12 text-left">
                <h3 className="text-xl font-bold text-slate-800 mb-6 leading-tight">Technische Sicherheit</h3>
                <p className="text-[16px] text-slate-600 leading-relaxed">
                  Wir haben technische und organisatorische Maßnahmen getroffen, um einen möglichst umfassenden Schutz Ihrer Daten zu gewährleisten. Dennoch weisen wir darauf hin, dass internetbasierte Datenübertragungen grundsätzlich Sicherheitslücken aufweisen können.
                </p>
            </div>
            
              {/* Card 3 - Ihre Rechte */}
              <div className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 py-12 text-left">
                <h3 className="text-xl font-bold text-slate-800 mb-6 leading-tight">Ihre Rechte</h3>
                <p className="text-[16px] text-slate-600 leading-relaxed">
                  Sie haben jederzeit das Recht auf Auskunft, Berichtigung, Löschung oder Einschränkung der Verarbeitung Ihrer personenbezogenen Daten. Zudem klären wir Sie über Ihre weiteren Rechte auf.
              </p>
            </div>
            </div>
          </div>
        </div>
      </div>

      {/* Purple Section - Begriffserklärungen */}
      <div className="bg-primary-900 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-5">
          {/* Left Side - Text (3 columns) */}
          <div className="lg:col-span-3 p-12 lg:p-20 flex items-center">
            <div className="max-w-2xl">
              <div className="w-16 h-16 mb-8">
                <FileText className="w-16 h-16 text-white" />
        </div>

              <h2 className="text-4xl md:text-5xl font-light text-gold-400 mb-8 leading-tight">
                <em className="italic">Begriffserklärungen</em>
          </h2>
          
              <p className="text-xl text-primary-100 leading-relaxed">
                Diese Datenschutzerklärung basiert auf den Definitionen der DSGVO und soll für alle verständlich sein. 
                Nachfolgend erläutern wir einige zentrale Begriffe für besseres Verständnis.
              </p>
            </div>
          </div>
          
          {/* Right Side - Image (2 columns) */}
          <div className="lg:col-span-2 relative min-h-96">
            <div 
              className="absolute inset-0 bg-cover bg-center"
              style={{backgroundImage: 'url(/images/sv-office-building.jpg)'}}
            ></div>
          </div>
        </div>
        </div>

      {/* Large Content Section - All Legal Text */}
      <div className="bg-white py-16">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24">
          <div className="prose prose-lg max-w-none text-slate-700">
            
            <div className="mb-12">
              <h3 className="text-2xl font-bold text-slate-800 mb-6">Einführung</h3>
              <p className="text-base leading-relaxed mb-6">
                Wir freuen uns über Ihr Interesse an Sky View Asset Management. Der Schutz Ihrer persönlichen Daten hat für uns höchste Priorität. Die Nutzung unserer Website ist grundsätzlich ohne Angabe personenbezogener Daten möglich. Wenn Sie jedoch bestimmte Services über unsere Website in Anspruch nehmen möchten, kann die Verarbeitung solcher Daten erforderlich werden. In diesem Fall holen wir – sofern keine gesetzliche Grundlage besteht – Ihre ausdrückliche Einwilligung ein.
              </p>
              <p className="text-base leading-relaxed mb-6">
                Die Verarbeitung personenbezogener Daten (z. B. Name, Adresse, E-Mail oder Telefonnummer) erfolgt stets im Einklang mit der Datenschutz-Grundverordnung (DSGVO) sowie den nationalen Datenschutzbestimmungen. Mit dieser Datenschutzerklärung informieren wir Sie über Art, Umfang und Zweck der Datenerhebung und -verarbeitung. Zudem klären wir Sie über Ihre Rechte auf.
              </p>
              <p className="text-base leading-relaxed">
                Wir haben technische und organisatorische Maßnahmen getroffen, um einen möglichst umfassenden Schutz Ihrer Daten zu gewährleisten. Dennoch weisen wir darauf hin, dass internetbasierte Datenübertragungen grundsätzlich Sicherheitslücken aufweisen können. Sie können uns daher auch auf alternativen Wegen kontaktieren – z. B. telefonisch.
              </p>
            </div>
            
            <div className="mb-12">
              <h3 className="text-2xl font-bold text-slate-800 mb-6">Begriffserklärungen</h3>
              <p className="text-base leading-relaxed mb-6">
                Diese Datenschutzerklärung basiert auf den Definitionen der DSGVO und soll für alle verständlich sein. Nachfolgend erläutern wir einige zentrale Begriffe:
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <h4 className="font-bold text-slate-800 mb-2">Personenbezogene Daten:</h4>
                  <p className="text-sm text-slate-600 mb-4">Alle Informationen, die sich auf eine identifizierte oder identifizierbare Person beziehen (z. B. Name, E-Mail, IP-Adresse).</p>
                  
                  <h4 className="font-bold text-slate-800 mb-2">Betroffene Person:</h4>
                  <p className="text-sm text-slate-600 mb-4">Jede natürliche Person, deren personenbezogene Daten verarbeitet werden.</p>
                  
                  <h4 className="font-bold text-slate-800 mb-2">Verarbeitung:</h4>
                  <p className="text-sm text-slate-600 mb-4">Jeder Vorgang im Zusammenhang mit personenbezogenen Daten, z. B. Erhebung, Speicherung, Nutzung, Löschung.</p>
                  
                  <h4 className="font-bold text-slate-800 mb-2">Einschränkung der Verarbeitung:</h4>
                  <p className="text-sm text-slate-600 mb-4">Kennzeichnung gespeicherter Daten mit dem Ziel, deren Verarbeitung einzuschränken.</p>
                  
                  <h4 className="font-bold text-slate-800 mb-2">Profiling:</h4>
                  <p className="text-sm text-slate-600">Automatisierte Verarbeitung zur Bewertung bestimmter persönlicher Merkmale.</p>
                </div>
                <div>
                  <h4 className="font-bold text-slate-800 mb-2">Pseudonymisierung:</h4>
                  <p className="text-sm text-slate-600 mb-4">Verarbeitung in einer Weise, dass Daten ohne zusätzliche Infos keiner Person mehr zugeordnet werden können.</p>
                  
                  <h4 className="font-bold text-slate-800 mb-2">Verantwortlicher:</h4>
                  <p className="text-sm text-slate-600 mb-4">Die Stelle, die über Zweck und Mittel der Verarbeitung entscheidet.</p>
                  
                  <h4 className="font-bold text-slate-800 mb-2">Auftragsverarbeiter:</h4>
                  <p className="text-sm text-slate-600 mb-4">Dienstleister, die Daten im Auftrag des Verantwortlichen verarbeiten.</p>
                  
                  <h4 className="font-bold text-slate-800 mb-2">Empfänger:</h4>
                  <p className="text-sm text-slate-600 mb-4">Stelle, der personenbezogene Daten offengelegt werden.</p>
                  
                  <h4 className="font-bold text-slate-800 mb-2">Einwilligung:</h4>
                  <p className="text-sm text-slate-600">Eine freiwillige, informierte und eindeutige Zustimmung zur Verarbeitung personenbezogener Daten.</p>
            </div>
          </div>
        </div>

            <div className="mb-12">
              <h3 className="text-2xl font-bold text-slate-800 mb-6">Verantwortlicher im Sinne der DSGVO</h3>
              <div className="bg-slate-50 p-6 rounded-none">
                <p className="text-base leading-relaxed">
                  <strong>Sky View GmbH</strong><br/>
                  Bockenheimer Landstraße 17/19<br/>
                  60325 Frankfurt am Main<br/>
                  Deutschland<br/>
                  E-Mail: <a href="mailto:info@skyview-assets.de" className="text-primary-700 hover:text-gold-600 transition-colors">info@skyview-assets.de</a>
                </p>
              </div>
            </div>
            
            <div className="mb-12">
              <h3 className="text-2xl font-bold text-slate-800 mb-6">Cookies</h3>
              <p className="text-base leading-relaxed">
                Unsere Website verwendet Cookies – kleine Textdateien, die auf Ihrem Endgerät gespeichert werden. Sie dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Cookies ermöglichen z. B., dass Sie bei einem erneuten Besuch nicht erneut Ihre Zugangsdaten eingeben müssen oder dass Ihr Warenkorb im Online-Shop gespeichert bleibt. Sie können das Speichern von Cookies jederzeit in den Einstellungen Ihres Browsers deaktivieren. Beachten Sie bitte, dass bei deaktivierten Cookies eventuell nicht alle Funktionen unserer Website verfügbar sind.
              </p>
            </div>
            
            <div className="mb-12">
              <h3 className="text-2xl font-bold text-slate-800 mb-6">Server-Logfiles / Zugriffsdaten</h3>
              <p className="text-base leading-relaxed mb-4">
                Bei jedem Besuch unserer Website werden automatisch bestimmte Daten erfasst, wie z. B.:
              </p>
              <ul className="text-base text-slate-600 space-y-2 mb-4">
                <li>• Browsertyp und -version</li>
                <li>• Betriebssystem</li>
                <li>• Herkunftsseite</li>
                <li>• Datum und Uhrzeit des Zugriffs</li>
                <li>• IP-Adresse</li>
                <li>• Internet-Service-Provider</li>
                <li>• Besuchte Unterseiten</li>
              </ul>
              <p className="text-base leading-relaxed">
                Diese Daten dienen ausschließlich statistischen Zwecken, zur Verbesserung der Website und zur Abwehr von Angriffen. Rückschlüsse auf konkrete Personen werden daraus nicht gezogen.
              </p>
            </div>

            <div className="mb-12">
              <h3 className="text-2xl font-bold text-slate-800 mb-6">Registrierung auf der Website</h3>
              <p className="text-base leading-relaxed">
                Sie können sich auf unserer Website registrieren. Die dafür erforderlichen personenbezogenen Daten ergeben sich aus dem jeweiligen Formular. Ihre Daten werden ausschließlich für interne Zwecke und zur Bereitstellung unserer Leistungen verwendet. Bei der Registrierung speichern wir zusätzlich Ihre IP-Adresse sowie Datum und Uhrzeit. Diese Maßnahme dient der Missbrauchsprävention. Eine Weitergabe Ihrer Daten erfolgt nur, wenn gesetzliche Pflichten bestehen oder dies zur Durchsetzung von Rechten notwendig ist. Registrierte Nutzer können ihre Daten jederzeit ändern oder löschen lassen. Auf Anfrage informieren wir Sie gerne über die gespeicherten Daten.
              </p>
            </div>
            
            <div className="mb-12">
              <h3 className="text-2xl font-bold text-slate-800 mb-6">Kontaktaufnahme</h3>
              <p className="text-base leading-relaxed">
                Wenn Sie uns über E-Mail oder ein Kontaktformular erreichen, speichern wir die von Ihnen übermittelten Daten ausschließlich zur Bearbeitung Ihrer Anfrage. Eine Weitergabe an Dritte erfolgt nicht.
              </p>
            </div>
            
            <div className="mb-12">
              <h3 className="text-2xl font-bold text-slate-800 mb-6">Rechte der betroffenen Person</h3>
              <p className="text-base leading-relaxed mb-6">
                Im Rahmen der Datenschutz-Grundverordnung (DSGVO) stehen Ihnen als betroffene Person verschiedene Rechte zu, die Sie gegenüber der Sky View GmbH (Kontaktdaten siehe oben) geltend machen können. Nachfolgend erhalten Sie eine Übersicht dieser Rechte:
              </p>
              
              <div className="space-y-6">
                <div>
                  <h4 className="font-bold text-slate-800 mb-2">a) Recht auf Bestätigung</h4>
                  <p className="text-sm text-slate-600">Sie haben das Recht, eine Bestätigung darüber zu verlangen, ob bei der Sky View GmbH personenbezogene Daten von Ihnen verarbeitet werden.</p>
                </div>
                
                <div>
                  <h4 className="font-bold text-slate-800 mb-2">b) Recht auf Auskunft</h4>
                  <p className="text-sm text-slate-600 mb-2">Sie können jederzeit unentgeltlich Auskunft über die zu Ihrer Person gespeicherten personenbezogenen Daten verlangen. Die Auskunft umfasst unter anderem:</p>
                  <ul className="text-sm text-slate-600 space-y-1 ml-4">
                    <li>• den Zweck der Datenverarbeitung</li>
                    <li>• die Kategorien der verarbeiteten Daten</li>
                    <li>• Empfänger oder Kategorien von Empfängern (auch in Drittländern)</li>
                    <li>• die geplante Speicherdauer</li>
                    <li>• das Bestehen eines Rechts auf Berichtigung, Löschung, Einschränkung oder Widerspruch</li>
                    <li>• das Beschwerderecht bei einer Aufsichtsbehörde</li>
                  </ul>
                </div>
                
                <div>
                  <h4 className="font-bold text-slate-800 mb-2">c) Recht auf Berichtigung</h4>
                  <p className="text-sm text-slate-600">Sie können die unverzügliche Korrektur unrichtiger oder unvollständiger personenbezogener Daten verlangen.</p>
                </div>
                
                <div>
                  <h4 className="font-bold text-slate-800 mb-2">d) Recht auf Löschung ("Recht auf Vergessenwerden")</h4>
                  <p className="text-sm text-slate-600 mb-2">Sie haben das Recht, die Löschung Ihrer personenbezogenen Daten zu verlangen, sofern einer der folgenden Gründe zutrifft:</p>
                  <ul className="text-sm text-slate-600 space-y-1 ml-4">
                    <li>• Die Daten sind für den ursprünglichen Zweck nicht mehr notwendig</li>
                    <li>• Sie widerrufen Ihre Einwilligung, und es fehlt an einer anderweitigen Rechtsgrundlage</li>
                    <li>• Sie legen Widerspruch ein, und es bestehen keine vorrangigen berechtigten Gründe</li>
                    <li>• Die Daten wurden unrechtmäßig verarbeitet</li>
                    <li>• Die Löschung ist zur Erfüllung gesetzlicher Verpflichtungen erforderlich</li>
                  </ul>
            </div>
                
                <div>
                  <h4 className="font-bold text-slate-800 mb-2">e) Recht auf Einschränkung der Verarbeitung</h4>
                  <p className="text-sm text-slate-600 mb-2">Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer Daten zu verlangen, wenn:</p>
                  <ul className="text-sm text-slate-600 space-y-1 ml-4">
                    <li>• Sie die Richtigkeit der Daten bestreiten (für die Dauer der Prüfung)</li>
                    <li>• die Verarbeitung unrechtmäßig ist, Sie jedoch keine Löschung wünschen</li>
                    <li>• die Daten nicht mehr benötigt werden, Sie sie jedoch für Rechtsansprüche benötigen</li>
                    <li>• Sie Widerspruch gegen die Verarbeitung eingelegt haben</li>
                  </ul>
          </div>
                
                <div>
                  <h4 className="font-bold text-slate-800 mb-2">f) Recht auf Datenübertragbarkeit</h4>
                  <p className="text-sm text-slate-600">Sie können verlangen, dass wir Ihnen oder einem anderen Verantwortlichen die von Ihnen bereitgestellten personenbezogenen Daten in einem strukturierten, gängigen und maschinenlesbaren Format übermitteln.</p>
        </div>

                <div>
                  <h4 className="font-bold text-slate-800 mb-2">g) Recht auf Widerspruch</h4>
                  <p className="text-sm text-slate-600">Sie haben das Recht, jederzeit gegen die Verarbeitung Ihrer Daten Widerspruch einzulegen, wenn diese auf Art. 6 Abs. 1 lit. e oder f DSGVO beruht.</p>
              </div>
              </div>
            </div>

            <div className="mb-12">
              <h3 className="text-2xl font-bold text-slate-800 mb-6">Rechtsgrundlagen der Verarbeitung</h3>
              <p className="text-base leading-relaxed mb-4">
                Sky View GmbH verarbeitet Ihre personenbezogenen Daten auf Grundlage der folgenden Rechtsgrundlagen:
              </p>
              <ul className="text-base text-slate-600 space-y-2">
                <li>• Art. 6 Abs. 1 lit. a DSGVO – Einwilligung</li>
                <li>• Art. 6 Abs. 1 lit. b DSGVO – Erfüllung eines Vertrags oder vorvertraglicher Maßnahmen</li>
                <li>• Art. 6 Abs. 1 lit. c DSGVO – gesetzliche Verpflichtung</li>
                <li>• Art. 6 Abs. 1 lit. d DSGVO – lebenswichtige Interessen</li>
                <li>• Art. 6 Abs. 1 lit. f DSGVO – berechtigtes Interesse des Unternehmens</li>
              </ul>
          </div>

            <div className="mb-12">
              <h3 className="text-2xl font-bold text-slate-800 mb-6">Kontaktaufnahme per E-Mail, Telefon oder Telefax</h3>
              <p className="text-base leading-relaxed">
                Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, verarbeiten wir die dabei übermittelten personenbezogenen Daten (z. B. Name, Anfrage) zur Bearbeitung Ihres Anliegens. Die Verarbeitung erfolgt zur Vertragserfüllung oder Durchführung vorvertraglicher Maßnahmen (Art. 6 Abs. 1 lit. b DSGVO), auf Grundlage unseres berechtigten Interesses (Art. 6 Abs. 1 lit. f DSGVO), oder mit Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Ihre Daten werden gelöscht, sobald der Zweck der Speicherung entfällt – sofern keine gesetzlichen Aufbewahrungspflichten bestehen.
              </p>
        </div>

      </div>
    </div>
  </div>

      {/* Green Banner - Datensicherheit */}
      <div className="bg-primary-800 py-16">
        <div className="max-w-[1720px] mx-auto px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 text-center">
          <div className="max-w-3xl mx-auto">
            <div className="w-16 h-16 bg-white/20 rounded-none flex items-center justify-center mx-auto mb-8">
              <Lock className="w-8 h-8 text-white" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Ihre Daten sind sicher
            </h2>
            <p className="text-xl text-primary-100 mb-8 leading-relaxed">
              Als Finanzdienstleister unterliegen wir besonderen Sicherheitsanforderungen. 
              Ihre Daten sind bei uns in sicheren Händen.
            </p>
            <Link to="/contact">
              <Button className="bg-white text-primary-700 hover:bg-gray-100 px-8 py-4 text-lg font-medium rounded-none shadow-lg border border-gray-200">
                <span className="text-primary-700 font-bold">Bei Fragen kontaktieren Sie uns</span>
                <ArrowRight className="ml-2 w-5 h-5 text-primary-700" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </PublicShell>
  );
};

export default DatenschutzPage;
